import { DOCUMENT_NAME_VALUES } from "@core/core.constants";
import type { DocumentInformation } from "@core/core.types";

import type { DocAggregatedByCategoriesType } from "../Documents.types";

const ACCEPTED_FORMATS = ["xls", "ods", "xlsx", "csv"];

export const formatDocumentsByCategory: (
  documents: DocumentInformation[],
) => DocAggregatedByCategoriesType = (documents) => {
  const copy = Object.keys(DOCUMENT_NAME_VALUES).reduce(
    (acc, key) => ({
      ...acc,
      [key]: {
        documentsPdf: [],
        documentsXls: [],
      },
    }),
    {},
  ) as DocAggregatedByCategoriesType;

  documents.forEach((doc) => {
    if (doc.fileExtension === "pdf") {
      copy[doc.documentType].documentsPdf.push(doc);
    } else if (ACCEPTED_FORMATS.includes(doc.fileExtension)) {
      copy[doc.documentType].documentsXls.push(doc);
    }
  });

  return copy;
};
